import { useLanguage } from "../contexts/LanguageContext";

const PolitiqueConfidentialitePage = () => {
  const { t } = useLanguage();

  return (
    <div data-testid="politique-confidentialite-page" className="min-h-screen bg-slate-50 pt-24 pb-16">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <h1 className="text-4xl font-bold text-[#0F172A] mb-8">Politique de Confidentialité</h1>
        
        <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8">
          {/* Introduction */}
          <section>
            <p className="text-slate-600 leading-relaxed">
              Nettis Facility SRL accorde une grande importance à la protection de vos données personnelles. 
              Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons 
              et protégeons vos données personnelles conformément au Règlement Général sur la Protection des 
              Données (RGPD) et à la législation belge en vigueur.
            </p>
          </section>

          {/* Responsable du traitement */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">1. Responsable du traitement</h2>
            <div className="text-slate-600 space-y-2">
              <p><strong>Nettis Facility SRL</strong></p>
              <p>Avenue Louise 65 boîte 11, 1050 Bruxelles, Belgique</p>
              <p>BCE : 0788.309.595</p>
              <p>Email : info@nettis.be</p>
              <p>Téléphone : +32 2 880 66 50</p>
            </div>
          </section>

          {/* Données collectées */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">2. Données personnelles collectées</h2>
            <p className="text-slate-600 mb-4">Nous collectons les données suivantes :</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li><strong>Formulaire de contact :</strong> nom, prénom, email, téléphone, entreprise, message</li>
              <li><strong>Candidatures :</strong> nom, prénom, email, téléphone, CV, lettre de motivation</li>
              <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées (via cookies analytiques)</li>
            </ul>
          </section>

          {/* Finalités */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">3. Finalités du traitement</h2>
            <p className="text-slate-600 mb-4">Vos données sont traitées pour les finalités suivantes :</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li>Répondre à vos demandes de contact et de devis</li>
              <li>Traiter vos candidatures</li>
              <li>Améliorer notre site web et nos services</li>
              <li>Établir des statistiques de fréquentation</li>
              <li>Respecter nos obligations légales</li>
            </ul>
          </section>

          {/* Base légale */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">4. Base légale du traitement</h2>
            <p className="text-slate-600 mb-4">Le traitement de vos données est fondé sur :</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li><strong>Votre consentement</strong> (cookies analytiques, newsletter)</li>
              <li><strong>L'exécution d'un contrat</strong> ou de mesures précontractuelles (demandes de devis)</li>
              <li><strong>Notre intérêt légitime</strong> (amélioration de nos services, sécurité du site)</li>
              <li><strong>Le respect d'obligations légales</strong></li>
            </ul>
          </section>

          {/* Durée de conservation */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">5. Durée de conservation</h2>
            <p className="text-slate-600 mb-4">Vos données sont conservées pendant :</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li><strong>Formulaire de contact :</strong> 3 ans à compter du dernier contact</li>
              <li><strong>Candidatures :</strong> 2 ans après réception (sauf opposition de votre part)</li>
              <li><strong>Données de navigation :</strong> 13 mois maximum</li>
              <li><strong>Données clients :</strong> durée de la relation commerciale + 10 ans (obligations comptables)</li>
            </ul>
          </section>

          {/* Destinataires */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">6. Destinataires des données</h2>
            <p className="text-slate-600 mb-4">Vos données peuvent être transmises à :</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li>Notre personnel autorisé (service commercial, RH)</li>
              <li>Nos sous-traitants techniques (hébergement, maintenance)</li>
              <li>Les autorités compétentes en cas d'obligation légale</li>
            </ul>
            <p className="text-slate-600 mt-4">
              Nous ne vendons ni ne louons vos données personnelles à des tiers.
            </p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">7. Cookies</h2>
            <p className="text-slate-600 mb-4">Notre site utilise les cookies suivants :</p>
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-slate-600 border border-slate-200 rounded-lg">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold">Type</th>
                    <th className="px-4 py-3 text-left font-semibold">Finalité</th>
                    <th className="px-4 py-3 text-left font-semibold">Durée</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t border-slate-200">
                    <td className="px-4 py-3">Cookies nécessaires</td>
                    <td className="px-4 py-3">Fonctionnement du site, préférences cookies</td>
                    <td className="px-4 py-3">Session / 1 an</td>
                  </tr>
                  <tr className="border-t border-slate-200">
                    <td className="px-4 py-3">Cookies analytiques</td>
                    <td className="px-4 py-3">Statistiques de fréquentation (PostHog)</td>
                    <td className="px-4 py-3">13 mois</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-slate-600 mt-4">
              Vous pouvez gérer vos préférences de cookies via la bannière affichée lors de votre première visite 
              ou en effaçant les cookies de votre navigateur.
            </p>
          </section>

          {/* Droits */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">8. Vos droits</h2>
            <p className="text-slate-600 mb-4">Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
              <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
              <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
              <li><strong>Droit à la limitation :</strong> restreindre le traitement de vos données</li>
              <li><strong>Droit à la portabilité :</strong> récupérer vos données dans un format structuré</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
              <li><strong>Droit de retirer votre consentement</strong> à tout moment</li>
            </ul>
            <p className="text-slate-600 mt-4">
              Pour exercer vos droits, contactez-nous à : <strong>info@nettis.be</strong>
            </p>
          </section>

          {/* Réclamation */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">9. Réclamation</h2>
            <p className="text-slate-600">
              Si vous estimez que le traitement de vos données personnelles constitue une violation du RGPD, 
              vous avez le droit d'introduire une réclamation auprès de l'Autorité de protection des données (APD) :
            </p>
            <div className="mt-4 p-4 bg-slate-50 rounded-lg text-slate-600">
              <p><strong>Autorité de protection des données</strong></p>
              <p>Rue de la Presse 35, 1000 Bruxelles</p>
              <p>Tél : +32 2 274 48 00</p>
              <p>Email : contact@apd-gba.be</p>
              <p>Site : <a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener noreferrer" className="text-[#1E3A8A] hover:underline">www.autoriteprotectiondonnees.be</a></p>
            </div>
          </section>

          {/* Sécurité */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">10. Sécurité des données</h2>
            <p className="text-slate-600">
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger 
              vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction. 
              Ces mesures incluent le chiffrement des données, des pare-feu, des contrôles d'accès et des 
              audits réguliers de sécurité.
            </p>
          </section>

          {/* Modifications */}
          <section>
            <h2 className="text-2xl font-semibold text-[#1E3A8A] mb-4">11. Modifications</h2>
            <p className="text-slate-600">
              Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. 
              Toute modification sera publiée sur cette page avec une date de mise à jour. Nous vous 
              encourageons à consulter régulièrement cette page.
            </p>
          </section>

          {/* Date de mise à jour */}
          <section className="pt-4 border-t border-slate-200">
            <p className="text-sm text-slate-500">
              Dernière mise à jour : Juillet 2025
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialitePage;
